import './glider'
import './thumbnail'
//import './zoom'

jQuery(function ($) {
  $('.tangible-glider').each(function () {
    $(this).tangibleGlider()
  })
})
